import React from "react";
import BoardOfDirectorsSection from "../../components/Investor/BoardOfDirectors.tsx";
import MetaComponent from "../../components/CommonComponents/MetaComponent.tsx";
const BoardOfDirectors = () => {
  return (
    <>
      <MetaComponent
        title="Board of Directors and Committees | Aptech Limited"
        desc="Explore the leadership team of our organization including stakeholders committee and other key board members."
        keywords="Board of Directors, Leadership Team, CSR Committee"
      />
      <div>
        <BoardOfDirectorsSection />
      </div>
    </>
  );
};

export default BoardOfDirectors;
